<p-toast></p-toast>
<div class="page-wrapper customer-file-page pb-5">
  <div class="container">
    <div class="customer-file-page-inner">
      <div class="wrap-title d-flex align-items-center justify-content-between gap-2">
        <h2 class="title p-0 m-0">{{isEdit ? (checkDisplaySaveButton() ? 'MODIFICATION DU CLIENT / PROSPECT' : 'VOIR DU CLIENT / PROSPECT') :
          'CRÉER UN CLIENT'}}</h2>
        <button *ngIf="checkDisplaySaveButton()" (click)="save()" class="btn-common btn-save">ENREGISTRER</button>
      </div>
      <div class="wrap-content-tab">
        <p-tabView (onChange)="onTabChange($event)">
          <p-tabPanel header="Informations clients">
            <div class="wrap-tab tab-1">
              <p class="title">Informations clients</p>
              <span class="required description">* Champs obligatoires</span>
              <form [formGroup]="infoCustomerForm" class="">
                <div class="wrap-form row">
                  <div class="mb-2 px-1 py-2 col-xl-3 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">Code <span class="required">*</span></label>
                      <input formControlName="code" type="text" placeholder="Code Adhérent" />
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-5 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">Raison sociale <span class="required">*</span></label>
                      <input formControlName="companyName" type="text" placeholder="Raison sociale" />
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">SIRET <span class="required">*</span></label>
                      <input formControlName="siret" type="text" placeholder="SIRET" />
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
                    <div class="wrap-select">
                      <!-- <label for="">TVA</label>
                      <input formControlName="vat" type="text" placeholder="TVA" /> -->
                      <label for="">Type de client</label>
                      <p-dropdown formControlName="typeOfCustomer" class="w-12" [options]="listTypeUser"
                        optionLabel="label" optionValue="id" placeholder="Type de client"></p-dropdown>
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-5 col-lg-12 col-md-12">
                    <div class="wrap-input-file">
                      <span>Votre logo</span>
                      <div class="d-flex" style="align-items: center; gap: 0.5rem">
                        <img style="width: 50px;"
                          *ngIf="infoCustomerForm?.value?.logo?.length && infoCustomerForm?.value?.logo[0]?.url"
                          [src]="infoCustomerForm.value.logo[0].url" />
                        <div *ngIf="checkDisplaySaveButton()" class="d-flex" style="height: fit-content">
                          <label for="votre-logo">
                            SÉLECTIONNER VOTRE FICHIER
                            <input (change)="selectImage($event)" type="file" id="votre-logo">
                          </label>
                          <a *ngIf="nameFile && infoCustomerForm?.value?.logo?.length && infoCustomerForm?.value?.logo[0]?.url"
                            class="name-file ml-1" href="{{infoCustomerForm.value?.logo[0]?.url}}">{{
                            nameFile }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-8 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">Adresse</label>
                      <input formControlName="address" type="text" placeholder="Adresse" />
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">Complément d'adresse</label>
                      <input formControlName="additionalAddress" type="text" placeholder="Complément d'adresse" />
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-3 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">Code postal</label>
                      <input formControlName="postcode" type="text" placeholder="Code postal" />
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">Ville</label>
                      <input formControlName="city" type="text" placeholder="Ville" />
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-5 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">Pays</label>
                      <p-dropdown formControlName="country" class="w-12" [options]="listCountry" optionLabel="label"
                        optionValue="id" placeholder="Pays"></p-dropdown>
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">Téléphone</label>
                      <input formControlName="phone" type="text" placeholder="Téléphone" />
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">Fax</label>
                      <input formControlName="fax" type="text" placeholder="Fax" />
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">E-mail</label>
                      <input formControlName="email" type="text" placeholder="E-mail" />
                    </div>
                  </div>
                  <div class="mb-2 px-1 py-2 col-xl-12 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">Site web</label>
                      <input formControlName="website" type="text" placeholder="Site web" />
                    </div>
                  </div>
                  <!-- <div class="mb-2 col-xl-4 col-lg-6 col-md-12">
                    <div class="wrap-input">
                      <label for="">Forme juridique</label>
                      <input formControlName="status" type="text" placeholder="Forme juridique" />
                    </div>
                  </div> -->
                </div>
              </form>
            </div>
          </p-tabPanel>
          <p-tabPanel header="Contacts">
            <div class="wrap-tab tab-2">
              <div class="wrap-form-tab mb-5">
                <p class="title">Contacts clients</p>
                <div class="wrap-form row">
                  <form [formGroup]="infoContactForm" class="row">
                    <div class="p-2 px-1 col-xl-4 col-lg-6 col-md-12">
                      <div class="wrap-input">
                        <label for="">Civilité</label>
                        <p-dropdown formControlName="civility" class="w-12" [options]="listCivility" optionLabel="label"
                          optionValue="parameterId" placeholder="Civilité"></p-dropdown>
                      </div>
                    </div>
                    <div class="p-2 px-1 col-xl-4 col-lg-6 col-md-12">
                      <div class="wrap-input">
                        <label for="">Prénom</label>
                        <input formControlName="firstName" type="text" placeholder="Prénom" />
                      </div>
                    </div>
                    <div class="p-2 px-1 col-xl-4 col-lg-6 col-md-12">
                      <div class="wrap-input">
                        <label for="">Nom</label>
                        <input formControlName="lastName" type="text" placeholder="Nom" />
                      </div>
                    </div>
                    <div class="p-2 px-1 col-xl-4 col-lg-6 col-md-12">
                      <div class="wrap-input">
                        <label for="">Téléphone</label>
                        <input formControlName="phone" type="text" placeholder="Téléphone" />
                      </div>
                    </div>
                    <div class="p-2 px-1 col-xl-4 col-lg-6 col-md-12">
                      <div class="wrap-input">
                        <label for="">E-mail</label>
                        <input formControlName="email" type="text" placeholder="E-mail" />
                      </div>
                    </div>
                    <div class="p-2 px-1 col-xl-4 col-lg-6 col-md-12">
                      <div class="wrap-input">
                        <label for="">Fonction</label>
                        <input formControlName="job" type="text" placeholder="Fonction" />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="wrap-table">
                <p-table [value]="listContacts">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="font-bold" style="min-width: 180px">Fonction</th>
                      <th class="font-bold">Prénom</th>
                      <th class="font-bold">Nom</th>
                      <th class="font-bold" style="min-width: 100px; max-width: 150px">
                        Téléphone
                      </th>
                      <th class="font-bold" style="width: 200px">Email</th>
                      <th class="font-bold" style="width: 100px">Actions</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item>
                    <tr>
                      <td class="font-bold">{{ item?.job ? item?.job : '-' }}</td>
                      <td class="">{{ item?.firstName ? item?.firstName : '-' }}</td>
                      <td class="">{{ item?.lastName ? item?.lastName : '-' }}</td>
                      <td class="underline">
                        <a style="color: #082234;" *ngIf="item?.phone" href="tel:{{ item?.phone }}">{{ item?.phone
                          }}</a>
                        <p *ngIf="!item?.phone">-</p>
                      </td>
                      <td class="underline">
                        <a style="color: #082234;" *ngIf="item?.email" href="mailto:{{ item?.email }}">{{ item?.email
                          }}</a>
                        <p *ngIf="!item?.email">-</p>
                      </td>
                      <td>
                        <button (click)="editItemContact(item)" class="btn-clear p-1">
                          <i class="pi" [ngClass]="[checkDisplaySaveButton() ? 'pi-pencil' : 'pi-eye']"
                            style="font-size: 16px; color: #003967; position: relative; top: 3px;"></i>
                        </button>
                        <button *ngIf="checkDisplaySaveButton()" (click)="showDialogDelRow(item)" class="btn-clear p-1">
                          <img src="src-adisco/assets/images/icon/trash.svg" alt="">
                        </button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </div>
</div>
<p-dialog header="Supprimer la ligne" [modal]="true" [(visible)]="visibleRow" [style]="{ width: '600px' }">
  <div class="popup-del-row">
    <p>Êtes-vous sûr de vouloir supprimer ces données ?</p>
    <div class="d-flex justify-content-end px-2">
      <button class="btn-common btn-save btn-delete py-2" (click)="confirmDeleteCustomer()">OUI</button>
    </div>
  </div>
</p-dialog>